import React, { useState, useEffect } from 'react';
import { noteTemplateAPI } from '../../services/api';
import './SellerProfiles.css';

const EMPTY_FORM = { title: '', note: '' };

const NoteTemplates = () => {
  const [templates, setTemplates]   = useState([]);
  const [loading, setLoading]       = useState(true);
  const [showForm, setShowForm]     = useState(false);
  const [editing, setEditing]       = useState(null);
  const [formData, setFormData]     = useState(EMPTY_FORM);

  useEffect(() => { fetchTemplates(); }, []);

  const fetchTemplates = async () => {
    try {
      const res = await noteTemplateAPI.getAll();
      if (res.success) setTemplates(res.data);
    } catch {
      alert('Failed to fetch note templates');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editing) {
        const res = await noteTemplateAPI.update(editing.id, formData);
        if (res.success) { alert('Note template updated'); fetchTemplates(); resetForm(); }
      } else {
        const res = await noteTemplateAPI.create(formData);
        if (res.success) { alert('Note template created'); fetchTemplates(); resetForm(); }
      }
    } catch (err) {
      const msg = err.response?.data?.errors
        ? Object.values(err.response.data.errors)[0][0]
        : 'Failed to save note template';
      alert(msg);
    }
  };

  const handleEdit = (template) => {
    setEditing(template);
    setFormData({ title: template.title, note: template.note });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this note template?')) return;
    try {
      const res = await noteTemplateAPI.delete(id);
      if (res.success) { alert('Note template deleted'); fetchTemplates(); }
    } catch {
      alert('Failed to delete note template');
    }
  };

  const resetForm = () => {
    setFormData(EMPTY_FORM);
    setEditing(null);
    setShowForm(false);
  };

  if (loading) return <div className="loading">Loading note templates...</div>;

  return (
    <div className="seller-profiles-container">
      <div className="profiles-header">
        <h2>Note Templates</h2>
        <button onClick={() => { resetForm(); setShowForm(!showForm); }} className="create-btn">
          {showForm ? 'Cancel' : '+ Add Note Template'}
        </button>
      </div>

      {showForm && (
        <div className="profile-form-card">
          <h3>{editing ? 'Edit' : 'Create'} Note Template</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-field full-width">
                <label>Title *</label>
                <input
                  type="text"
                  name="title"
                  value={formData.title}
                  onChange={handleInputChange}
                  placeholder="e.g., Payment Terms, Standard Disclaimer"
                  required
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-field full-width">
                <label>Note Content *</label>
                <textarea
                  name="note"
                  value={formData.note}
                  onChange={handleInputChange}
                  rows="4"
                  placeholder="Enter the note content that will appear on the invoice…"
                  required
                />
              </div>
            </div>

            <div className="form-actions">
              <button type="button" onClick={resetForm} className="cancel-btn">Cancel</button>
              <button type="submit" className="submit-btn">
                {editing ? 'Update' : 'Create'} Template
              </button>
            </div>
          </form>
        </div>
      )}

      <div className="profiles-grid">
        {templates.length === 0 ? (
          <div className="empty-state">
            <p>No note templates yet. Create one to reuse notes across invoices.</p>
          </div>
        ) : (
          templates.map((t) => (
            <div key={t.id} className="profile-card">
              <h3>{t.title}</h3>
              <div className="profile-details">
                <p className="address" style={{ whiteSpace: 'pre-wrap' }}>{t.note}</p>
              </div>
              <div className="profile-actions">
                <button onClick={() => handleEdit(t)} className="edit-btn">Edit</button>
                <button onClick={() => handleDelete(t.id)} className="delete-btn">Delete</button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NoteTemplates;
